// Copyright (c) 2017 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import criteria from './criteria';
import gridApi from './grid-api';
import report from './report';
import reportIsScrollable from '../../shared/reducers/report-is-scrollable';
import showNoResultsFound from '../../shared/reducers/show-no-results-found';
import territories from './territories';

export const getCombinedReducers = () =>
    combineReducers({
        busyCounter,
        criteria,
        gridApi,
        report,
        reportIsScrollable,
        showNoResultsFound,
        territories
    });



// WEBPACK FOOTER //
// ./src/reports/special-allowance-claim-status/reducers/index.js